import store from '@/store'

/**
 * 前端菜单资源文件，存储了整个系统所有需要权限访问的菜单和具体操作
 * 菜单支持到2级
 */
export default {

    // 通用菜单，这些功能是根据使用者的权限身份来判断的，没有具体主账号
    // 通过判断是否存在具体角色来判断是否显示系统菜单，auth传入的主账号以及对应的资源ID列表
    commonTable: () => [
        '*集团财务.*财务审批.财务审批',
        '*集团财务.*财务审批.审批',
        '*集团财务.*财务审批.驳回',

        '*集团财务.*报销审批.报销审批',
        '*集团财务.*报销审批.审批申请',

        '*系统管理.*主体管理.主体管理',
        '*系统管理.*主体管理.创建主体',
        '*系统管理.*主体管理.编辑主体',

        '*系统管理.*角色管理.角色管理',

        '*系统管理.*用户管理.用户管理',
        '*系统管理.*用户管理.创建新用户',
        '*系统管理.*用户管理.编辑用户',
        '*系统管理.*用户管理.编辑用户权限',
    ],

    // 资源菜单，这些功能是有具体的主体操作对象的
    sourcesTable: () => [
        // 店铺业务
        '*店铺业务.*数据图表.数据图表',

        // '*店铺业务.*账务录入.账务录入',
        // '*店铺业务.*账务录入.来源设定',

        // 供货商业务
        '*供货商业务.*店铺派单.店铺派单',

        '*供货商业务.*工单管理.工单管理',
        '*供货商业务.*工单管理.接受工单',
        '*供货商业务.*工单管理.取消工单',
        '*供货商业务.*工单管理.工单发货',
        '*供货商业务.*工单管理.工单加急',
        '*供货商业务.*工单管理.发起扣款',

        '*供货商业务.*扣款管理.扣款管理',
        '*供货商业务.*扣款管理.同意扣款',
        '*供货商业务.*扣款管理.取消扣款',

        '*供货商业务.*供货设置.供货设置',

        // 主体财务
        '*主体财务.*收支明细.收支明细',

        '*主体财务.*充值提现.充值提现',
        '*主体财务.*充值提现.充值',
        '*主体财务.*充值提现.提现',

        '*主体财务.*账务报销.账务报销',
        '*主体财务.*账务报销.发起申请',
        '*主体财务.*账务报销.取消申请',
    ],

    // 主体账户类型表，这个表是有序表
    mainuser_type: () => ['店铺', '供货商'],

    // 给route用的，判断访问的路由是系统资源还是主账号的业务资源
    isSystemSource: source_id => this.commonTable().indexOf(source_id) > -1,

    /**
     * @param Serving           员工的任职信息表格
     * @param User              用户信息
     */
    init(Serving, User) {
        //先按照主账号和账号类型进行分类
        const servinginfo = {}, typetable = {};
        Serving.forEach(item => {
            if (servinginfo[item.主账号] === undefined) {
                servinginfo[item.主账号] = [item]
            } else {
                servinginfo[item.主账号].push(item);
            }

            if (typetable[item.主账号类型] === undefined) {
                typetable[item.主账号类型] = [item.主账号];
            } else {
                if (typetable[item.主账号类型].indexOf(item.主账号) === -1)
                    typetable[item.主账号类型].push(item.主账号);
            }
        });

        //再取出所有主账号的角色API列表
        // 2020 10 11 存储一份api权限表 {主账号:[api]}
        let allapilist = [], mainuserlist = {}, api权限表 = {};
        for (const key in servinginfo) {
            let apilist = [], sources = [];
            servinginfo[key].forEach(item => {
                apilist = [...apilist, ...(item.角色API权限 || [])]; //取出这个主账号下所有的API权限
                sources = [...sources, ...(item.角色关联资源ID || [])]; //取出这个主账号下所有的角色关联资源ID
            });

            allapilist = [...allapilist, ...apilist];
            if (mainuserlist[key] === undefined) mainuserlist[key] = [];
            if (api权限表[key] === undefined) api权限表[key] = [];

            //2020 08 15 修复：多个角色具有交叉的资源ID时，sources执行去重操作
            mainuserlist[key] = [...mainuserlist[key], ...sources.unique()];
            api权限表[key] = [...api权限表[key], ...apilist.unique()];
        }

        // allapilist放到全局对象中，供CALLAPI函数使用
        // store.commit('setApilist', allapilist.unique());

        //2020 08 15 修复：将资源ID按照基准表排序，防止绘制时出现错乱。
        const left = this.sourcesTable();   //左侧是基准表
        for (const key in mainuserlist) {
            //复制左表，循环检测是否存在右表中，存在的加入到结果表，得出的结果就是标准顺序的表
            const right = window.deepCopy(mainuserlist[key]);   //右侧是待处理的表
            const result = [];

            left.forEach(资源ID => {
                if (right.indexOf(资源ID) > -1) result.push(资源ID);
            });

            mainuserlist[key] = result;
        }

        let commonmenu = this.commonTable();   //左侧是基准表
        //复制左表，循环检测是否存在右表中，存在的加入到结果表，得出的结果就是标准顺序的表
        const right = window.deepCopy(User.系统职权 || []);   //右侧是待处理的表
        commonmenu = commonmenu.filter(资源ID => right.indexOf(资源ID) > -1);

        // 存储一份资源ID列表，用于资源ID查询
        const commonmenulist = window.deepCopy(commonmenu); // {主账号:[资源ID列表]}

        //根据主账号初始化最终表，与通用表
        // 将字符串型资源ID，转换成数组，并去掉*号菜单标识
        let commontreearray = commonmenu.map(item => item.split('.').map(_item => _item.replace('*', '')));
        // 先按照菜单组合去重 注意⚠：这里只做了两层的菜单支持
        let menus = []; //[{label:name,children:[]}]
        const basetree = {};
        commontreearray.forEach(array => {
            //数组转为树
            const foo = (object, path, dep) => {
                if (dep === 2) return; //最大到第二层
                let key = path.shift();
                if (object[key] === undefined) object[key] = dep === 0 ? {} : false;
                foo(object[key], path, ++dep);
            };
            foo(basetree, array, 0);
            //构建菜单树
            const foo1 = (object, dep) => {
                if (dep === 2) return;

                let arr = Object.keys(object);
                return arr.map(key => {
                    const obj = { label: key };
                    if (object[key]) obj.children = foo1(object[key], dep + 1);
                    return obj
                });
            };
            menus = foo1(basetree, 0);
        });

        commonmenu = menus;

        // 存储一份资源ID列表，用于资源ID查询
        const sourcelist = window.deepCopy(mainuserlist); // {主账号:[资源ID列表]}
        const mainuser_menu = window.deepCopy(mainuserlist)

        //根据主账号初始化最终表，与通用表
        for (const key in mainuser_menu) {
            // 将字符串型资源ID，转换成数组，并去掉*号菜单标识
            let sourcetreearray = mainuser_menu[key].map(item => item.split('.').map(_item => _item.replace('*', '')));
            // 先按照菜单组合去重 注意⚠：这里只做了两层的菜单支持
            let menus = []; //[{label:name,children:[]}]
            const basetree = {};
            sourcetreearray.forEach(array => {
                //数组转为树
                const foo = (object, path, dep) => {
                    if (dep === 2) return; //最大到第二层
                    let key = path.shift();
                    if (object[key] === undefined) object[key] = dep === 0 ? {} : false;
                    foo(object[key], path, ++dep);
                };
                foo(basetree, array, 0);
                //构建菜单树
                const foo1 = (object, dep) => {
                    if (dep === 2) return;

                    let arr = Object.keys(object);
                    return arr.map(key => {
                        const obj = { label: key };
                        if (object[key]) obj.children = foo1(object[key], dep + 1);
                        return obj
                    });
                };
                menus = foo1(basetree, 0);
            });
            mainuser_menu[key] = menus
        }

        //按照分类表分类
        // for (const cate in typetable) typetable[cate] = typetable[cate].map(key => mainuser_menu[key]);

        //得到{主账号:[菜单列表]}
        return { typetable, mainuser_menu, sourcelist, commonmenu, commonmenulist, api权限表 };
    },


    // const 员工表 = []
    // return [...全局表, ...员工表];
    //由基准表转为数据表
    //获取的任职信息转换为数据存储至后端

    /**
     * 生成供角色管理中的资源树数据结构
     * @param is_sources true 默认生成主账号资源ID，否则生成通用系统树
     */
    generateResourceTree(is_sources = true) {
        const basetree = {};
        // 构建基本树
        (is_sources ? this.sourcesTable() : this.commonTable()).forEach((item) => {
            const foo = (object, path) => {
                if (path.length === 1) {
                    object[path] = [];
                } else {
                    let key = path.shift();
                    if (object[key] === undefined) object[key] = {};
                    foo(object[key], path);
                }
            };

            foo(basetree, item.split('.'));
        });

        // 构建 vue 组件树
        const foo1 = (object, path = '') => {
            if (typeof object === 'string') return false;
            const keys = Object.keys(object), result = [];
            if (keys.length === 0) return false;

            for (let i = 0; i < keys.length; i++) {
                const id = path === '' ? keys[i] : `${path}.${keys[i]}`;
                const node = { id: id, label: keys[i], };
                const children = foo1(object[keys[i]], id);
                if (children) node.children = children;
                result.push(node);
            }
            return result;
        }

        let result = foo1(basetree);
        return result ? result : [];
    }




}